import { Toast } from "vant";
import axios from "axios";

export const appId = "wx9b8dda7df119e4c7"
// export const baseUrl = "http://mallqr-open.baomen.net"
export const baseUrl = "https://mqr-open.barcodebox.cn"
export const headers = { authSignature: "cb0553aa8e2ac50d0c9e3b56e2a30896" }

export function wxConfig(wx, cb) {
  let data = {
    url: window.location.href,
  };
  axios
    .get("/api/wechat/Open/GetSignature", {
      params: data,
      headers,
    })
    .then((resp) => {
      if (resp.data.errorNumber === 0) {
        wx.config({
          // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId, // 必填，公众号的唯一标识
          timestamp: Number(resp.data.data.timestamp), // 必填，生成签名的时间戳
          nonceStr: resp.data.data.noncestr, // 必填，生成签名的随机串
          signature: resp.data.data.signature, // 必填，签名
          jsApiList: ["checkJsApi", "scanQRCode", "getLocation"], // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
          cb && cb();
        });
        wx.error(function (res) {
          console.log("错误", res);
        });
      } else {
        Toast("获取微信接口失败");
      }
    });
}

/**
 * @param key 参数的key | undefined
 * @returns 参数的value | 所有参数组成的对象 | undefined
 * @des 返回结果一定是字符串，如果需要其他类型，需要手动转换
 */
 export function getUrlParams(key) {
    const { search } = window.location;
    if (search === '') return undefined;
    const res = Object.fromEntries(
      decodeURI(search.replace('?', ''))
        .split('&')
        .map((item) => item.split('=')),
    );
    return key ? res[key] : res;
  }